module.exports = __webpack_public_path__ + "static/img/CHEVROLET.8afd716.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/CHEVROLET.png
// module id = RWnP
// module chunks = 1